export default __webpack_public_path__ + "static/media/EverydayCircusOne.b4af74ac.jpg";